import type { CSSProperties, ComponentType, SVGProps } from "react";
import {
  DottedArcBlueLargeIcon,
  DottedArcOrangeSmallIcon,
  DottedArcCyanLargeIcon,
  DottedArcCyanSmallIcon,
  DottedArcBlueSmallIcon,
  DottedArcBlueMediumIcon,
  DottedArcGreenIcon,
  DottedArcTealRotatedIcon,
  DottedArcTealLeftIcon,
} from "./icons";

export const REGISTER_SUCCESS_FIGMA_FRAME_WIDTH = 1440;
export const REGISTER_SUCCESS_FIGMA_FRAME_MIN_HEIGHT = 960;

export type RegisterSuccessDecorationId =
  | "topRightBlue"
  | "topCenterOrange"
  | "leftCyan"
  | "leftBlueSmall"
  | "bottomCenterBlue"
  | "bottomGreen"
  | "bottomRightCyan"
  | "bottomRightTealRotated"
  | "bottomLeftTeal";

export interface RegisterSuccessDecorationConfig {
  readonly id: RegisterSuccessDecorationId;
  readonly Icon: ComponentType<Readonly<SVGProps<SVGSVGElement>>>;
  readonly placement: CSSProperties;
  readonly iconProps?: Readonly<SVGProps<SVGSVGElement>>;
}

export const REGISTER_SUCCESS_DECORATIONS: readonly RegisterSuccessDecorationConfig[] = [
  {
    id: "topRightBlue",
    Icon: DottedArcBlueLargeIcon,
    placement: { width: "169px", height: "168px", right: "114px", top: "171px" },
    iconProps: { width: 169, height: 168 },
  },
  {
    id: "topCenterOrange",
    Icon: DottedArcOrangeSmallIcon,
    placement: {
      width: "113px",
      height: "113px",
      right: "605px",
      top: "197px",
      transform: "rotate(90deg)",
      transformOrigin: "center",
    },
    iconProps: { width: 122, height: 123 },
  },
  {
    id: "leftCyan",
    Icon: DottedArcCyanLargeIcon,
    placement: { width: "211px", height: "211px", left: "32px", top: "196px" },
    iconProps: { width: 229, height: 227 },
  },
  {
    id: "leftBlueSmall",
    Icon: DottedArcBlueSmallIcon,
    placement: { width: "76px", height: "76px", left: "32px", bottom: "302px" },
    iconProps: { width: 76, height: 76 },
  },
  {
    id: "bottomCenterBlue",
    Icon: DottedArcBlueMediumIcon,
    placement: { width: "116px", height: "117px", right: "595px", bottom: "265px" },
    iconProps: { width: 116, height: 117 },
  },
  {
    id: "bottomGreen",
    Icon: DottedArcGreenIcon,
    placement: { width: "124px", height: "123px", right: "295px", bottom: "389px" },
    iconProps: { width: 124, height: 126 },
  },
  {
    id: "bottomRightCyan",
    Icon: DottedArcCyanSmallIcon,
    placement: { width: "76px", height: "77px", right: "32px", bottom: "504px" },
    iconProps: { width: 101, height: 100 },
  },
  {
    id: "bottomRightTealRotated",
    Icon: DottedArcTealRotatedIcon,
    placement: {
      width: "75.606px",
      height: "77.06px",
      right: "130.822px",
      bottom: "280.804px",
      transform: "rotate(-97.358deg)",
      transformOrigin: "center",
    },
    iconProps: { width: 99, height: 99 },
  },
  {
    id: "bottomLeftTeal",
    Icon: DottedArcTealLeftIcon,
    placement: {
      width: "75px",
      height: "76px",
      left: "289px",
      bottom: "454px",
    },
    iconProps: { width: 99, height: 99 },
  },
];
